import { render, staticRenderFns } from "./yonghxwgf_config.vue?vue&type=template&id=3c3ceccf&scoped=true"
import script from "./yonghxwgf_config.vue?vue&type=script&lang=js"
export * from "./yonghxwgf_config.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3ceccf",
  null
  
)

export default component.exports